module.exports = __webpack_public_path__ + "static/image-49414c7c6048da5e358293c54a8f24d7.svg";